import type { CompanyType, UsageReportsType } from 'api/api.types';
import type { ComposedReturnType } from 'lib/api';

// TODO: Remove after V1 is deployed with the new shape
export function massageUsageReports(company: CompanyType) {
  const { usageReports } = company;

  const {
    consumer = '',
    curator = '',
    individual = '',
    leaderboards = '',
  } = usageReports || {};

  if (consumer) {
    company.usageReports = {
      'consumer-usage': {
        overview: consumer as string,
        leaderboards: leaderboards as string,
        individual: individual as string,
      },
      curator,
      'competitive-analytics': {
        overview: '',
        'threat-analysis': '',
        'rep-performance': '',
        impact: '',
        'data-hygiene': '',
      },
      individual,
    } as UsageReportsType;
  }
}

/**
 * The Salesforce instance (and its card metadata) is now loaded lazily by the
 * dynamic-data model the first time an SFDC card actually needs it
 * (see `ensureSalesforceInstance`), rather than eagerly on every company load.
 * This avoids a live Salesforce request for users/boards that have no SFDC
 * data cards at all.
 */
const companyInterceptor = (response: ComposedReturnType<CompanyType>) => {
  const data: CompanyType = response.data;

  massageUsageReports(data);
  return response;
};

export default companyInterceptor;
